import type { AxiosError } from 'axios';
import { i18n } from '@/shared/i18n';

interface ProblemDetails {
  detail?: string;
  title?: string;
}

export function getPersonaFetchErrorMessage(error: unknown): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const data = (error as AxiosError<ProblemDetails>).response?.data;
    if (data?.detail) {
      return data.detail;
    }
    if (data?.title) {
      return data.title;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return i18n.t('audiences:persona.getPersonaFetchErrorMessage.somethingWentWrongWhileLoading');
}
